import React from 'react';
import * as Yup from 'yup';
import { FaEdit } from 'react-icons/fa';

import OneFlavorPizza from '../../../../../../assets/one-flavor-pizza.svg';
import TwoFlavorsPizza from '../../../../../../assets/two-flavors-pizza.svg';
import ThreeFlavorsPizza from '../../../../../../assets/three-flavors-pizza.svg';
import FourFlavorsPizza from '../../../../../../assets/four-flavors-pizza.svg';

import { ISize } from '../../../../../../models';

import {
  Container,
  Header,
  SizesList,
  SizeItem,
  SizeItemDetails,
  EditSizesButton,
} from './styles';

type SizesProps = {
  sizes: ISize[];
};

export const SizesFormSchema = Yup.object().shape({});

const Sizes: React.FC<SizesProps> = ({ sizes }) => {
  function handleNumOfFlavorsText(numOfFlavors: number): string {
    if (numOfFlavors === 1) {
      return `Até 1 sabor`;
    }

    return `Até ${numOfFlavors} sabores`;
  }

  function handleNumOfSlicesText(numOfSlices: number): string {
    if (numOfSlices === 1) {
      return `Possui 1 pedaço`;
    }

    return `Possui ${numOfSlices} pedaços`;
  }

  function renderSizeItemImage(numOfFlavors: number): JSX.Element {
    switch (numOfFlavors) {
      case 1: {
        return (
          <img
            className="one-flavor"
            src={OneFlavorPizza}
            alt="Pizza de um sabor"
          />
        );
      }
      case 2: {
        return (
          <img
            className="two-flavors"
            src={TwoFlavorsPizza}
            alt="Pizza de dois sabores"
          />
        );
      }
      case 3: {
        return (
          <img
            className="three-flavors"
            src={ThreeFlavorsPizza}
            alt="Pizza de três sabores"
          />
        );
      }
      case 4: {
        return (
          <img
            className="four-flavors"
            src={FourFlavorsPizza}
            alt="Pizza de quatro sabores"
          />
        );
      }
      default: {
        return (
          <img
            className="four-flavors"
            src={FourFlavorsPizza}
            alt="Pizza de quatro sabores"
          />
        );
      }
    }
  }

  return (
    <Container>
      <Header>
        <h2>Tamanhos</h2>
        <p>
          Veja aqui quais os tamanhos que suas pizzas são produzidas, em quantos
          pedaços são cortadas e até quantos sabores seu restaurante monta cada
          tamanho
        </p>
      </Header>
      <SizesList>
        {sizes.map((size) => (
          <SizeItem key={size.id}>
            {renderSizeItemImage(size.numOfFlavors)}
            <SizeItemDetails>
              <h3>{size.name}</h3>
              <p>{handleNumOfFlavorsText(size.numOfFlavors)}</p>
              <p>{handleNumOfSlicesText(size.numOfSlices)}</p>
            </SizeItemDetails>
          </SizeItem>
        ))}
      </SizesList>
      <EditSizesButton to="/configuracoes/8/0">
        <FaEdit /> Editar tamanhos
      </EditSizesButton>
    </Container>
  );
};

export default Sizes;
